import { Link } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import { translateWithFallback } from '../utils/translateWithFallback';

/**
 * Figma: muted "← Back to Home" under the site header, above page title (top-left content).
 * Hide on /home via callers; keeps SiteSettings CSS vars only.
 */
const BackToHomeLink = () => {
    const { t } = useTranslation();
    const label = translateWithFallback(t, 'nav.backToHome', 'Back to Home');

    return (
        <Link
            to="/home"
            className="mb-3 inline-flex min-h-11 items-center gap-1 text-sm font-medium text-[color-mix(in_srgb,var(--text-color),transparent_25%)] transition hover:text-[var(--text-color)] hover:underline"
        >
            <span aria-hidden className="text-base leading-none">
                ←
            </span>
            {label}
        </Link>
    );
};

export default BackToHomeLink;
